module.exports = __webpack_public_path__ + "static/media/03_banner.41d29ca8.jpg";